export default __webpack_public_path__ + "static/media/offline.ae02003a.svg";